/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';

export default class SubmenuItem extends Component {
  // Services
  @service
  session;

  // Props
  // active specifies whether the item should be highlighted.
  // Used for highlighting the current route.
  active = false;

  // available specifies whether the submenu item is viewable.
  available = true;

  // enabled specifies whether the submenu item is enabled, if not, a tooltip
  // stating the feature isn't enabled is displayed.
  enabled = true;

  // href provides the url route to go to when clicked.
  href = '';

  // icon provides the icon to display in the menu.
  icon = '';

  // name provides the name of the item to display in the menu.
  name = '';

  // onClick provides the callback handler for when the submenu item is
  // clicked.
  onClick() {}

  // target provides the href target.
  target = '';
}
